var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _vm._m(0),
    _c("div", { staticClass: "panel-body" }, [
      _c("div", { staticClass: "table-responsive" }, [
        _c(
          "table",
          { staticClass: "table table-bordered table-happy nomargin" },
          [
            _vm._m(1),
            _c(
              "tbody",
              [
                _vm.historiesChanged.length > 0
                  ? _vm._l(_vm.historiesChanged, function(hist) {
                      return _c("tr", { key: hist.id }, [
                        _c("td", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(hist.createDate) +
                              "\n                            "
                          )
                        ]),
                        _c(
                          "td",
                          {
                            staticStyle: { "border-left-width": "10px" },
                            style: {
                              "border-left-color": _vm.statusColor(
                                hist.historyContent
                              )
                            }
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(hist.historyContent) +
                                "\n                            "
                            )
                          ]
                        )
                      ])
                    })
                  : _vm._e(),
                _vm.historiesChanged.length === 0 ? [_vm._m(2)] : _vm._e()
              ],
              2
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [_vm._v("Lịch sử trạng thái")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "w200" }, [_vm._v("Ngày thay đổi")]),
        _c("th", [_vm._v("Nội dung")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("td", { attrs: { colspan: "3" } })])
  }
]
render._withStripped = true

export { render, staticRenderFns }